module.exports = __webpack_public_path__ + "img/Win or lose-min.41a91dd5.png";